import { FC, Ref } from 'react'

import { Box } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import contractVersions from 'modules/contracts/store/collections/contractVersions'
import { isVisible } from 'modules/custom_resources/lib/utils'
import type Field from 'modules/custom_resources/store/models/customResources/Field'
import type Resource from 'modules/custom_resources/store/models/customResources/Resource'
import type Schema from 'modules/custom_resources/store/models/customResources/Schema'
import type Value from 'modules/custom_resources/store/models/customResources/Value'
import type Employee from 'modules/employees/store/models/Employee'

import CustomTable from './_CustomTable'

interface Props {
  schemas: Schema[]
  fields: Field[]
  resources?: Resource[]
  values?: Value[]
  attachableId: number
  attachableType: string
  employee: Employee
  schemaRefs: Ref<HTMLElement>[]
  canManage: boolean
  canAddValues: boolean
}

const ListComponent: FC<Props> = ({
  schemas,
  fields,
  resources,
  values,
  attachableId,
  attachableType,
  schemaRefs,
  employee,
  canManage,
  canAddValues,
}) => (
  <>
    {schemas.map((schema, key) => {
      const schemaFields = fields.filter(
        (f) =>
          f.get('schema_id') === schema.get('id') &&
          isVisible(employee, contractVersions)(f.attributes.visible)
      )

      if (schemaFields.length === 0) return null

      const schemaResource = resources?.find((r) => r.get('schema_id') === schema.get('id'))
      let schemaValues: Value[] | undefined = []

      if (schemaResource) {
        schemaValues = values?.filter((v) => v.get('resource_id') === schemaResource.attributes.id)
      }

      return (
        <Box key={key} ref={schemaRefs[key]} paddingTop="s16" paddingBottom="s80">
          <CustomTable
            key={key}
            schema={schema}
            fields={schemaFields}
            resource={schemaResource}
            values={schemaValues}
            attachableId={attachableId}
            attachableType={attachableType}
            canManage={canManage}
            canAddValues={canAddValues}
          />
        </Box>
      )
    })}
  </>
)

export default observer(ListComponent)
